import productsApi from "@/api/product";

const state = {
    isLoading: false,
    isMore: null,
    nextPage: 1,
    products: null,
}
export const mutationTypes = {
    clearProducts: '[products_viewed] clearProducts',
    appendProducts: '[products_viewed] appendProducts',
    setIsLoading: '[products_viewed] setIsLoading',
    setIsMore: '[products_viewed] setIsMore',
    setNextPage: '[products_viewed] setNextPage'
}
export const actionTypes = {
    getProducts: '[products_viewed] getProducts',
}

export const getterTypes = {
    products: '[products_viewed] products',
    isLoading: '[products_viewed] isLoading',
    isMore: '[products_viewed] isMore'
}
const mutations = {
    [mutationTypes.appendProducts](state, orders) {
        if (state.products === null){
            const arrProxy = new Proxy(orders, {
              get(target, prop) {
                if (prop === 'push') {
                  return (...args) => {
                    console.log(...args);
                    return target[prop](...args);
                  };
                }
                return target[prop];
              }
            });
            state.products = arrProxy
        } else {
            orders.forEach((order) => {
                const found = state.products.find((element) => element.id === order.id);
                if (!found){
                    state.products.push(order)
                }
            })
        }
    },
    [mutationTypes.clearProducts](state){
        state.products = null
        state.nextPage = 1
        state.isMore = null
    },
    [mutationTypes.setIsLoading](state, value){
        state.isLoading = value
    },
    [mutationTypes.setIsMore](state, value){
        state.isMore = value
    },
    [mutationTypes.setNextPage](state, value){
        state.nextPage = value
    }
}

const getters = {
    [getterTypes.products]: state => {
        return state.products
    },
    [getterTypes.isLoading]: state => {
        return state.isLoading
    },
    [getterTypes.isMore]: state => {
        return state.isMore
    }
}

const actions = {
    [actionTypes.getProducts](context) {
        context.commit(mutationTypes.setIsLoading, true)
        let credentials = {}
        if (state.nextPage){
            credentials.page = state.nextPage
        }
        return new Promise(resolve => {
            productsApi
                .getProductsViewed(credentials)
                .then(response => {
                    console.log('response:', response)

                    context.commit(mutationTypes.appendProducts, response.data['results'])
                    context.commit(mutationTypes.setIsLoading, false)

                    if (response.data['next']){
                        context.commit(mutationTypes.setIsMore, true)
                        const url = new URL(response.data['next']);
                        const urlParams = new URLSearchParams(url.search);
                        const nextPage = parseInt(urlParams.get('page'))
                        context.commit(mutationTypes.setNextPage, nextPage)
                        console.log('Next page:', nextPage)
                    } else {
                        context.commit(mutationTypes.setNextPage, null)
                        context.commit(mutationTypes.setIsMore, false)
                    }
                    resolve(response.data['results'])
                })
                .catch(result => {
                    context.commit(mutationTypes.setIsLoading, false)
                    console.log('Result Errors:', result)
                })
        })
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}